function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import { Radio, Form, Button, Checkbox, message, Divider, Alert, Descriptions } from 'antd';
import { Container, Col, Row } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var NewPrescription = function NewPrescription(_ref) {
  var _ref$patient = _ref.patient,
      patient = _ref$patient === void 0 ? null : _ref$patient,
      _ref$check = _ref.check,
      check = _ref$check === void 0 ? null : _ref$check;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      bilanOptions = _useState2[0],
      setBilanOptions = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deptOptions = _useState4[0],
      setDeptOptions = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      deptData = _useState6[0],
      setDeptData = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isFormProcessing = _useState8[0],
      setIsFormProcessing = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      errorMessage = _useState10[0],
      setErrorMessage = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      successMessage = _useState12[0],
      setSuccessMessage = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      itemsData = _useState14[0],
      setItemsData = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      itemsOptionsData = _useState16[0],
      setItemsOptionsData = _useState16[1];

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append("bilan", values.bilan);
    if (check == null) formData.append("medical_check_id", null);else formData.append("medical_check_id", check.id);
    formData.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + "setbilan", formData).then(function (response) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      if (response.data.status == 200) {
        setSuccessMessage("Bilan(s) prescrit avec succès");
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  var handleDeptChange = function handleDeptChange(e) {
    setItemsOptionsData([]);
    var ar = deptData.filter(function (d) {
      return d.id.toString() == e.target.value;
    });

    if (ar.length > 0) {
      ar.forEach(function (d) {
        d.services.forEach(function (s) {
          setItemsOptionsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [s]);
          });
        });
      });
    }
  };

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getservicetree').then(function (response) {
      if (response.data.status == 200) {
        var ars = response.data.services.filter(function (d) {
          return d.type == 2;
        });
        ars.forEach(function (d) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: d.label,
              value: d.id
            }]);
          });
          setDeptData(function (prev) {
            return [].concat(_toConsumableArray(prev), [d]);
          });
          d.services.forEach(function (s) {
            setItemsData(function (prev) {
              return [].concat(_toConsumableArray(prev), [s]);
            });
            s.medical_items.forEach(function (m) {
              setBilanOptions(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  label: m.label,
                  value: m.id
                }]);
              });
            });
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      fluid: true,
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsx("div", {
            className: "cool-radius",
            style: {
              background: '#FCD013'
            },
            children: /*#__PURE__*/_jsxs(Descriptions, {
              title: /*#__PURE__*/_jsx("b", {
                children: "CONSULTATION"
              }),
              column: 1,
              children: [/*#__PURE__*/_jsx(Descriptions.Items, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Nom"
                }),
                children: patient.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Items, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Pr\xE9nom"
                }),
                children: patient.firstname
              }), /*#__PURE__*/_jsx(Descriptions.Items, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Plaintes"
                }),
                children: check.plaintes
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 9,
          children: /*#__PURE__*/_jsxs(Form, {
            layout: "horizontal",
            form: form,
            onFinish: onFinish,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "department",
              children: /*#__PURE__*/_jsx(Radio.Group, {
                onChange: handleDeptChange,
                options: deptOptions,
                optionType: "button",
                buttonStyle: "solid"
              })
            }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: errorMessage,
              banner: true
            }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "success",
              message: successMessage,
              banner: true
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "bilan",
              rules: [{
                required: true,
                message: "Veuillez choisir une option"
              }],
              children: /*#__PURE__*/_jsx(Checkbox.Group, {
                name: "bilan",
                children: itemsOptionsData.map(function (i) {
                  return /*#__PURE__*/_jsxs("div", {
                    style: {
                      borderBottom: '1px solid #FCD013',
                      margin: '10px 0px',
                      padding: '25px 15px'
                    },
                    children: [/*#__PURE__*/_jsx("h5", {
                      style: {
                        color: '#2658A4',
                        textTransform: 'uppercase'
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: i.label
                      })
                    }), i.medical_items.filter(function (m) {
                      return m.service_id == i.id;
                    }).map(function (e) {
                      return /*#__PURE__*/_jsx(Checkbox, {
                        value: e.id,
                        children: /*#__PURE__*/_jsx("b", {
                          style: {
                            textTransform: 'uppercase'
                          },
                          children: e.label
                        })
                      }, e.id);
                    })]
                  }, i.id);
                })
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                disabled: itemsOptionsData.length == 0,
                htmlType: "submit",
                type: "primary",
                children: "Prescrire le bilan"
              })
            })]
          })
        })]
      })
    })
  });
};

export default NewPrescription;